<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (!formIsValid) {
      <div class="alert-warning">
        <p>
          <mat-icon class="alert-warning-icon">warning</mat-icon>
          All fields must be completed before proceeding.
        </p>
      </div>
    }
    <cotecna-dynamic-form
      #dynamicForm
      [sections]="sections"
      [config]="formConfig"
      >
    </cotecna-dynamic-form>
  </mat-card-content>
  <mat-card-actions align="end">
    <button id="cancel-clone-inspection" (click)="cancel()" mat-button>
      CANCEL
    </button>
    <button id="clone-inspection" (click)="edit()" mat-button color="primary">
      SAVE
    </button>
  </mat-card-actions>
</mat-card>
